import React from 'react'

import AxiomLayout from './layout/AxiomLayout'
import './App.css'
import { UserContext } from './contexts/UserContext'
import { Redirect } from 'react-router-dom'
function App() {
  return (
    <UserContext.Consumer>
      {(value) => {
        const currentPath = window.location.pathname

        if (value.user || value.joinUsUser) {
          return (
            <div className="App">
              <AxiomLayout />
            </div>
          )
        } else if (
          !value.user &&
          (currentPath.includes('joinus') || currentPath.includes('thankyou'))
        ) {
          return <Redirect to="/joinus/login" />
        } else {
          return <Redirect to="/login" />
        }
      }}
    </UserContext.Consumer>
  )
}

export default App
